import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import type { FiltersSchemaType } from "@website/widget/filter/filter.types";
import cloneDeep from "lodash-es/cloneDeep";
import isEmpty from "lodash-es/isEmpty";
import mapValues from "lodash-es/mapValues";
import omit from "lodash-es/omit";
import pickBy from "lodash-es/pickBy";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
type UseFiltersProperties = {
  schema: FiltersSchemaType;
};
export const useFilters = t0 => {
  const $ = _c(13);
  const {
    schema
  } = t0;
  const router = useRouter();
  let filterKeys;
  let t1;
  if ($[0] !== router || $[1] !== schema) {
    const filtersSchemaEntries = Object.entries(schema);
    filterKeys = filtersSchemaEntries.reduce(_temp, []);
    let t2;
    if ($[4] !== router) {
      t2 = k => isFilled(router.query[k]);
      $[4] = router;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = filterKeys.filter(t2);
    $[0] = router;
    $[1] = schema;
    $[2] = filterKeys;
    $[3] = t1;
  } else {
    filterKeys = $[2];
    t1 = $[3];
  }
  const selectedFiltersCount = t1.length;
  let t2;
  if ($[6] !== filterKeys || $[7] !== router) {
    t2 = function clearFilters() {
      router.replace({
        query: deepOmit(omit(router.query, filterKeys), isFilled)
      }, undefined, {
        shallow: true,
        scroll: false
      });
    };
    $[6] = filterKeys;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const clearFilters = t2;
  let t3;
  if ($[9] !== clearFilters || $[10] !== filterKeys || $[11] !== selectedFiltersCount) {
    t3 = {
      filterKeys,
      selectedFiltersCount,
      clearFilters
    };
    $[9] = clearFilters;
    $[10] = filterKeys;
    $[11] = selectedFiltersCount;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export const useFilterLayoutEffect = t0 => {
  const $ = _c(5);
  const {
    dontSyncScroll
  } = t0;
  const formReference = useRef(null);
  const lastScrollPosition = useRef(0);
  const {
    isMobile
  } = useViewPort();
  let t1;
  let t2;
  if ($[0] !== dontSyncScroll || $[1] !== isMobile) {
    t1 = () => {
      if (!isMobile && formReference.current && !dontSyncScroll) {
        const syncScrollBar = () => {
          if (formReference.current) {
            formReference.current.scrollTop = formReference.current.scrollTop + (window.scrollY - lastScrollPosition.current);
            lastScrollPosition.current = window.scrollY;
          }
        };
        window.addEventListener("scroll", syncScrollBar);
        return () => window.removeEventListener("scroll", syncScrollBar);
      }
    };
    t2 = [isMobile, dontSyncScroll];
    $[0] = dontSyncScroll;
    $[1] = isMobile;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      formRef: formReference
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export function useCityFilterState() {
  const $ = _c(8);
  const router = useRouter();
  const visible = router.query.filters_visible === "true";
  let t0;
  if ($[0] !== router) {
    t0 = () => router.push({
      pathname: router.pathname,
      query: deepOmit({
        ["filters_visible"]: true,
        ...omit(router.query, "filters_visible")
      }, isFilled)
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onOpenFilters = t0;
  let t1;
  if ($[2] !== router) {
    t1 = () => router.replace({
      pathname: router.pathname,
      query: deepOmit({
        ...omit(router.query, "filters_visible")
      }, isFilled)
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onCloseFilters = t1;
  let t2;
  if ($[4] !== onCloseFilters || $[5] !== onOpenFilters || $[6] !== visible) {
    t2 = {
      visible,
      onOpenFilters,
      onCloseFilters
    };
    $[4] = onCloseFilters;
    $[5] = onOpenFilters;
    $[6] = visible;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function useFilterTracking(t0) {
  const $ = _c(8);
  const {
    callback,
    schema
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const filtersStorage = useRef(t1);
  let t2;
  if ($[1] !== callback || $[2] !== router.query || $[3] !== schema) {
    t2 = () => {
      if (!callback) {
        return;
      }
      const previous = filtersStorage.current;
      const current = mapValues(schema, (_, key) => router.query[key]);
      const removed = pickBy(previous, (_v, key_0) => current[key_0] === undefined && _v !== undefined);
      filtersStorage.current = cloneDeep(current);
      if (!isEmpty(removed)) {
        callback({
          removed
        });
      }
    };
    $[1] = callback;
    $[2] = router.query;
    $[3] = schema;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== callback || $[6] !== router.query) {
    t3 = [router.query, callback];
    $[5] = callback;
    $[6] = router.query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
}
function _temp(s, t0) {
  const [name, schema_0] = t0;
  return schema_0.type === "range" ? [...s, schema_0.min_key, schema_0.max_key] : schema_0.type === "custom" ? [...s, ...schema_0.keys] : [...s, name];
}